import { call, put } from 'redux-saga/effects';
import { SagaIterator } from 'redux-saga';
import { PayloadAction } from '@reduxjs/toolkit';
import apiRequests from 'config/services';
import { assemblerConstants } from 'saga/actions/assembler';
import { takeLatest } from 'redux-saga/effects';
import { BuildEntityParams, iAssemblyModel, iAssemblyResponse, iVariantResponse } from 'store/types/assembler';
import { setassemblyModel } from 'store/slices/assemblyModelSlice';
import { sagaBuildAssemblyAction } from 'saga/actions/assembler';
import { setAssemblyResult } from 'store/slices/assemblyResultSlice';
import { setVariants } from 'store/slices/variantSlice';

export function* getAssemblySaga(
  action: PayloadAction<{ uuid: string }>
): SagaIterator {
  try {
    // Destructure from the action payload
    const { uuid } = action.payload;

    // Call your API function with both arguments
    const data: iAssemblyModel = yield call(apiRequests.getAssembly, uuid);

    // Save to global state
    yield put(setassemblyModel(data));
    yield put(sagaBuildAssemblyAction())
  } catch (e) {
  }
}

export function* getPreMadeAssemblySaga(
  action: PayloadAction<{ sid: string, p: BuildEntityParams }>
): SagaIterator {
  try {
    // Destructure from the action payload
    const { sid, p } = action.payload;

    // Call your API function with both arguments
    const data: iAssemblyResponse = yield call(apiRequests.getPreMadeAssembly, sid, p);
    // Save to global state
    yield put(setAssemblyResult(data));
  } catch (e) {
  }
}

export function* getVariantsSaga(
  action: PayloadAction<{ sid: string }>
): SagaIterator {
  try {
    const { sid } = action.payload
    // Call the async API
    const data: iVariantResponse = yield call(apiRequests.getVariants, sid)
    // Save to Redux
    yield put(setVariants(data))
  } catch (e) {
    console.error('Error in getVariantsSaga:', e)
  }
}

// Listener saga
export function* getAssemblyHook() {
  // on SAGA_GET_SEARCH_RESULTS action, run getSearchResultsSaga
  yield takeLatest(assemblerConstants.SAGA_GET_ASSEMBLY, getAssemblySaga)
}

// Listener saga
export function* getPreMadeAssemblyHook() {
  // on SAGA_GET_SEARCH_RESULTS action, run getSearchResultsSaga
  yield takeLatest(assemblerConstants.SAGA_GET_PREMADE_ASSEMBLY, getPreMadeAssemblySaga)
}

export function* getVariantsHook() {
  // on SAGA_GET_SEARCH_RESULTS action, run getSearchResultsSaga
  yield takeLatest(assemblerConstants.SAGA_GET_VARIANTS, getVariantsSaga)
}

